import React from 'react'
import { XMarkIcon } from '@heroicons/react/24/outline'

export default function TermsModal({ onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* backdrop */}
      <div
        className="absolute inset-0 bg-black opacity-50"
        onClick={onClose}
      />

      {/* modal */}
      <div className="relative bg-white rounded-lg shadow-lg max-w-xl w-full p-6 overflow-y-auto max-h-[90vh]">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Terms of Service</h2>
          <button onClick={onClose}>
            <XMarkIcon className="w-6 h-6 text-gray-700 hover:text-gray-900" />
          </button>
        </div>
        <div className="text-gray-700 text-sm space-y-4">
          <p><strong>Last updated:</strong> April 29, 2025</p>
          <p>Welcome to MyEventMitra. By accessing or using our website and services, you agree to the following terms:</p>
          <ol className="list-decimal pl-5 space-y-2">
            <li>
              <strong>Acceptance of Terms</strong><br/>
              You must be at least 18 years old and agree to these Terms before using our services.
            </li>
            <li>
              <strong>Services Provided</strong><br/>
              We act as a platform to connect event organizers with cultural service providers (vendors). We do not provide the services ourselves.
            </li>
            <li>
              <strong>User Accounts</strong><br/>
              • You are responsible for keeping your login credentials secure.<br/>
              • You must provide accurate and up-to-date information.<br/>
              • You may not share your account or impersonate others.
            </li>
            <li>
              <strong>User Conduct</strong><br/>
              You agree not to:<br/>
              • Post fraudulent, misleading, or unlawful content.<br/>
              • Harass, threaten, or harm others.<br/>
              • Bypass any security measures.
            </li>
            <li>
              <strong>Vendor Listings &amp; Transactions</strong><br/>
              • All agreements for services are directly between you and the vendor.<br/>
              • We are not a party to those agreements and assume no liability for vendor performance.
            </li>
            <li>
              <strong>Payments &amp; Fees</strong><br/>
              Currently, our platform is free to use. If we introduce fees, you will be notified in advance.
            </li>
            <li>
              <strong>Intellectual Property</strong><br/>
              • All content on MyEventMitra (text, graphics, logos) is our property or licensed to us.<br/>
              • You may not reproduce or distribute it without permission.
            </li>
            <li>
              <strong>Termination</strong><br/>
              We may suspend or terminate your access at any time for violations of these Terms.
            </li>
            <li>
              <strong>Disclaimers &amp; Limitation of Liability</strong><br/>
              • As-is: we provide the platform “as is” without warranties.<br/>
              • We are not liable for indirect, incidental, or consequential damages.
            </li>
            <li>
              <strong>Governing Law</strong><br/>
              These Terms are governed by the laws of [Your State], USA.
            </li>
            <li>
              <strong>Changes to Terms</strong><br/>
              We may modify these Terms. Continued use implies acceptance of the updated Terms.
            </li>
            <li>
              <strong>Contact</strong><br/>
              For any questions, email <a href="mailto:info@myeventmitra.com" className="text-orange-600 hover:underline">info@myeventmitra.com</a>.
            </li>
          </ol>
        </div>
      </div>
    </div>
  )
}